import React from 'react';
import { Flipper, Flipped } from 'react-flip-toolkit';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  ...draggableStyle,
  padding: 8,
});
const getListStyle = (isDraggingOver) => ({
  width: '100%',
});

const DraggableList = ({ items, setItems, renderItem }) => {
  const _flipKey = () => {
    const ids = items.map((item) => item.id);
    return [...ids].sort().join('');
  };

  const _onDragEnd = (result) => {
    const wasDroppedOutOfList = !result.destination;

    if (wasDroppedOutOfList) return;

    const newItems = _reorder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(newItems);
  };

  const _reorder = (items, startIndex, endIndex) => {
    const result = Array.from(items);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  return (
    <Flipper flipKey={_flipKey()}>
      <DragDropContext onDragEnd={_onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {items.map((item, index) => (
                <Flipped key={item.id} flipId={item.id}>
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => {
                      const isLastItem = index === items.length - 1;
                      const isDraggingOver = snapshot.isDragging;

                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          {renderItem(item, isLastItem, isDraggingOver, index)}
                        </div>
                      );
                    }}
                  </Draggable>
                </Flipped>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Flipper>
  );
};

export default DraggableList;
